<template>
    <el-dialog
        class="add"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="新增项目"
    >
        <div class="container">
            <el-form
                ref="addForm"
                :rules="rules"
                :model="addForm"
                label-width="110px"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="项目名称" size="small" prop="name">
                            <el-input
                                clearable
                                placeholder="请输入项目名称"
                                maxlength="30"
                                size="small"
                                v-model="addForm.name"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="项目类型" size="small" prop="type">
                            <el-select
                                v-model="addForm.type"
                                placeholder="请选择项目类型"
                                @change="typeChange"
                            >
                                <el-option
                                    label="短期项目"
                                    value="1"
                                ></el-option>
                                <el-option
                                    label="长期项目"
                                    value="2"
                                ></el-option>
                                <el-option
                                    label="运维项目"
                                    value="3"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" >
                        <el-form-item label="计划日期" size="small" prop="date" v-show="addForm.type==1">
                            <el-date-picker
                                v-model="addForm.date"
                                type="daterange"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="开始日期" size="small" prop="start_date" v-show="addForm.type!=1">
                            <el-date-picker
                                v-model="addForm.start_date"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="优先级"
                            size="small"
                            prop="priority"
                        >
                            <el-select
                                v-model="addForm.priority"
                                placeholder="请选择优先级"
                            >
                                <el-option
                                    :label="i"
                                    :value="i"
                                    v-for="i in 5"
                                    :key="i"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="负责人"
                            size="small"
                            prop="lead_user_id"
                        >
                            <el-select
                                v-model="addForm.lead_user_id"
                                clearable
                                filterable
                                placeholder="请选择负责人"
                                size="small"
                            >
                                <el-option
                                    v-for="item in staffList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="项目网址"
                            size="small"
                            prop="website"
                        >
                            <el-input
                                clearable
                                placeholder="请输入项目网址"
                                size="small"
                                v-model="addForm.website"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="团队成员" size="small" prop="Team">
                            <el-select
                                v-model="addForm.Team"
                                clearable
                                multiple
                                filterable
                                placeholder="请选择团队成员"
                                size="small"
                                @change="teamChange"
                            >
                                <el-option
                                    v-for="item in staffList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="项目描述" size="small" prop="desc">
                            <!-- <el-input
                                type="textarea"
                                clearable
                                placeholder="请输入项目描述"
                                :autosize="{ minRows: 5 }"
                                size="small"
                                v-model="addForm.desc"
                            >
                            </el-input> -->
                            <vue-tinymce
                                v-if="addVisible"
                                v-model="addForm.desc"
                                :setting="setting"
                                :setup="setup"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >保存</el-button
            >
            <el-button size="small" @click="addVisible = false">关闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
import * as publicApi from "@/http/publicApi.js";
import { mapState,mapActions } from "vuex";
export default {
    data() {
        return {
            addForm: {
                name: "",
                desc: "",
                date: [],
                start_date: "",
                end_date: "0000-00-00",
                type: "1",
                lead_user_id: "",
                Team: [],
                team: [],
                website: "",
                priority: 1,
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入项目名称",
                        trigger: "blur",
                    },
                ],
                desc: [
                    {
                        required: true,
                        message: "请输入项目描述",
                        trigger: "blur",
                    },
                ],
                type: [
                    {
                        required: true,
                        message: "请选择项目类型",
                        trigger: "change",
                    },
                ],
                priority: [
                    {
                        required: true,
                        message: "请选择优先级",
                        trigger: "change",
                    },
                ],
                lead_user_id: [
                    {
                        required: true,
                        message: "请选择负责人",
                        trigger: "change",
                    },
                ],
                date: [
                    {
                        required: true,
                        message: "请选择计划日期",
                        trigger: "blur",
                    },
                ],
                start_date: [
                    {
                        required: true,
                        message: "请选择开始日期",
                        trigger: "blur",
                    },
                ],
                Team: [
                    {
                        required: true,
                        message: "请选择团队成员",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    props: {
        addVisible: Boolean,
        tableItem: Object,
    },
    watch: {
        addVisible: {
            handler(newValue) {
                if (newValue) {
                    this.getStaffSelect();
                    this.addForm.lead_user_id = this.userInfo.id;
                    this.typeChange(1);
                }
            },
        },
    },
    created() {},
    methods: {
        ...mapActions(['getStaffSelect']),
        /**
         * 保存
         */
        save() {
            this.$refs["addForm"].validate((valid) => {
                if (valid) {
                    // 短期项目
                    if(this.addForm.type == 1){
                        this.addForm.start_date = this.addForm.date[0];
                        this.addForm.end_date = this.addForm.date[1];
                    }
                    this.addForm.team = this.addForm.Team.toString();
                    oaApi.project({ ...this.addForm }, "post").then((res) => {
                        if (res) {
                            this.$parent.project();
                            this.closeDialog();
                            this.$message.success("新增成功!");
                        }
                    });
                }
            });
        },
        /**
         * 关闭对话框
         */
        closeDialog() {
            this.$emit("update:addVisible", false);
            this.$refs["addForm"].resetFields();
            this.$refs["addForm"].clearValidate();
        },
        /**
         * 富文本失去焦点
         */
        setup(editor) {
            editor.on("blur", (e) => {
                this.$refs["addForm"].clearValidate("desc");
            });
            editor.on("KeyDown", e => {
                if ((e.keyCode == 8 || e.keyCode == 46) && editor.selection) {
                    // delete & backspace keys
                    var selectedNode = editor.selection.getNode(); // get the selected node (element) in the editor
                    if (selectedNode && selectedNode.nodeName == "IMG") {
                        publicApi
                            .delFile(
                                {
                                    image_url: selectedNode.src
                                },
                                "post"
                            )
                            .then(res => {
                                if (res.code == 200) {
                                }
                            })
                            .catch(err => {
                                return false;
                            });
                    }
                }
            });
        },
        /**
         * 团队成员下拉菜单改变时
         */
        teamChange(val){
            if(val){
                this.$refs["addForm"].clearValidate("Team");
            }
        },
        /**
         * 项目类型下拉菜单改变时
         */
        typeChange(val){
            let startDateRequired = false;
            let dateRequired = false;
            if(val == 1){
                startDateRequired = false;
                dateRequired = true;
            }else{
                startDateRequired = true;
                dateRequired = false;
            }
            this.$set(this.rules,"start_date",[
                {
                    required: startDateRequired,
                    message: "请选择开始日期",
                    trigger: "blur",
                },
            ])
            this.$set(this.rules,"date",[
                {
                    required: dateRequired,
                    message: "请选择计划日期",
                    trigger: "blur",
                },
            ])
        }
    },
    components: {},
    computed: {
        ...mapState({
            userInfo: (state) => state.login.userInfo, // 用户信息
            setting: (state) => state.index.setting,
            staffList: (state) => state.index.staffList,
        }),
    },
};
</script>

<style lang="scss" scoped>
.add {
    .el-dialog__body {
        padding: 20px 40px;
    }
    .el-select,
    .el-date-editor {
        width: 100%;
    }
    .el-form-item {
        .el-form-item__content {
            .el-radio {
                margin: 0;
                width: 100px;
            }
        }
    }
    .container {
        margin-top: 10px;
    }
}
</style>